import { Box } from '@/components/ui/box'
import { Divider } from '@/components/ui/divider'
import { HStack } from '@/components/ui/hstack'
import { Pressable } from '@/components/ui/pressable'
import { Text } from '@/components/ui/text'
import { VStack } from '@/components/ui/vstack'
import { participatedFormCoversSelectors } from '@/redux/slices/participatedFormCoversSlice'
import { useAppSelector } from '@/redux/store'
import dayjs from 'dayjs'
import { Link } from 'expo-router'
import { Fragment } from 'react'
import FormIcon from './FormIcon'

type ParticipatedFormItemProps = {
  formId: string
  showBorder: boolean
}

export default function ParticipatedFormItem({ formId, showBorder }: ParticipatedFormItemProps) {
  const participatedForm = useAppSelector(state =>
    participatedFormCoversSelectors.selectById(state, formId)
  )

  if (!participatedForm) {
    return null
  }

  const { form, entriesCount, lastEntryCreatedAt } = participatedForm
  const name = form.subname || form.name

  const descriptionItems = [
    lastEntryCreatedAt ? `${dayjs(lastEntryCreatedAt).format('YYYY-MM-DD')} 填写` : null,
    entriesCount > 0 ? `${entriesCount} 次填写` : null,
  ].filter(Boolean) as string[]

  return (
    <Link href={`/participated_forms/${form.token}/entries`} asChild>
      <Pressable className="data-[active=true]:bg-background-100">
        <HStack className="items-justify px-2">
          <Box className="p-4">
            <FormIcon scene={form.scene} />
          </Box>
          <VStack space="sm" className={`flex-1 justify-center py-2 mr-4 ${showBorder ? 'border-b border-background-100' : ''}`}>
            <Text size="body" className="text-label">
              {name}
            </Text>
            {descriptionItems.length > 0 && (
              <HStack space="sm" className="items-center">
                {descriptionItems.map((desc, index) => (
                  <Fragment key={index}>
                    {index > 0 && <Divider orientation="vertical" className="h-3/5" />}
                    <Text size="subhead" className="text-secondary-label">{desc}</Text>
                  </Fragment>
                ))}
              </HStack>
            )}
          </VStack>
        </HStack>
      </Pressable>
    </Link>
  )
}
